import { Container } from 'unstated';

export default class PageLoaderService extends Container {
  state = {
    isLoading: false,
    lazyLoadedPages: []
  };

  start = () => {
    this.setState({
      ...this.state,
      isLoading: true
    });
  };

  stop = () => {
    this.setState({
      ...this.state,
      isLoading: false
    });
  };

  addPageToLazyLoadedPages(page) {
    this.setState({
      ...this.state,
      lazyLoadedPages: [...this.state.lazyLoadedPages, page]
    });
  }

  isPageLoaded(page) {
    return this.state.lazyLoadedPages.includes(page)
  }
}

export const pageLoader = new PageLoaderService();
